export const tagNames = {
  source: 'sea-src',
  dataPath: 'sea-data',
  value: 'sea-val',
  valuelessHidden: 'sea-valueless-hidden',
  attributeName: 'sea-att',
  attributeValue: 'sea-att-val',
  attributeValuelessHidden: 'sea-att-valueless-hidden',
  attributeSet: 'sea-atts',
};
